<template>
  <div>
    <a-spin :spinning="isloading" tip="加载中...">
      <div class>
        <div class="pxkeji-right-box" style="margin-top:0">
          <pxkeji-btn name="导出" class="pxkeji_basic_btn" @click="uploadExcel()" type="primary" />
          <a-table
            :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
            :columns="list.columns"
            rowKey="id"
            :pagination="list.pagination"
            @change="onChange"
            :dataSource="list.datas"
            :loading="isloading"
            :locale="{emptyText:'暂无数据'}"
          >
            <!-- <span slot="action" slot-scope="action">
              <pxkeji-btn name="删除" @click="delInfo(action.id)" size="small" type="primary" />
            </span>-->
            <span slot="is_deleted" slot-scope="is_deleted"> 
                <a-tag v-if="is_deleted==1" color="red">已删除</a-tag>
                <a-tag v-else color="green">正常</a-tag>
              </span>
          </a-table>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
var that;
const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "序号"
  },
  {
    dataIndex: "fullName",
    key: "fullName",
    align: "center",
    title: "学员名称"
  },
  {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号"
  },

  {
    dataIndex: "gender",
    key: "gender",
    align: "center",
    title: "性别"
  },
   {
      dataIndex: "is_deleted",
      key: "is_deleted",
      align: "center",
      title: "状态",
      scopedSlots: { customRender: "is_deleted" },
    },
  {
    dataIndex: "company",
    key: "company",
    align: "center",
    title: "所属企业"
  }
 
];
export default {
  props: {
    id: String
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: ""
        }
      },
      selectRows: [], //选中项编号
      selectdata: {}, //选择撤机选项
      isloading: false,
      student: {
        //选择学员
        visible: false
      }
    };
  },
  components: {},
  mounted() {
    this.$nextTick(() => {
      that = this;
      this.GetList();
      //if (this.id) this.selectRows = [this.id];
    });
  },
  methods: {
    GetList() {
      this.list.pagination.total = 1;
      this.isloading = true;
      this.clearRows();
      this.$api.order
        .getStudentDetailed( this.list.pagination.current,
          this.list.pagination.defaultPageSize,this.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },

    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    //table 单选
    onRowChange(selectedRowKeys, selectedRows) {
      this.selectRows = selectedRowKeys;
      this.selectdata = selectedRows;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    //子组件传值
    save() {
      this.student.visible = false;
    },
    //导出
    uploadExcel() {
      window.location.href = this.$api.excel.exportOrderUser(this.id, this.selectRows.join(','));
    }
  }
};
</script>
<style>
</style>